import React from 'react';
import FloatingHero from '../../../../components/user/general/banner/Banner.js';
import maintainbannerImg from '../../../../assets/images/home/maintainbanner.jpg';
// import  '../../../../../assets/css/user/maintainance/Banner/Banner.css';
// Example 1: Repair Services Page
const Banner= () => {
  return (
    <>
      <FloatingHero
        title="Heavy Equipment Repair & Service"
        subtitle="20 years of combined experience serving valued commercial clients"
        backgroundImage={maintainbannerImg}
        darkOverlay={0.5}
      />
      {/* Rest of page content */}
    </>
  );
};

export default Banner;
// import React from 'react';
// import { Container } from 'react-bootstrap';
// import '../../../../../assets/css/maintain/subfolder/banner/Banner.css';

// const Banner= () => {
//   return (
//     <section className="floating-cta-section">
//       <div className="cta-background-image"></div>
//       <div className="cta-overlay"></div>
      
//       <Container className="cta-container">
//         <div className="cta-content">
//           <h2 className="cta-heading" data-aos="fade-up">
//             Heavy Equipment Repair & Service
//           </h2>
//           <div className="heading-decoration"></div>
//           <p className="cta-subheading" data-aos="fade-up" data-aos-delay="200">
//             20 years of combined experience serving valued commercial clients
//           </p>
//         </div>
//       </Container>
//     </section>
//   );
// };

// export default Banner;